module.exports = __webpack_public_path__ + "img/ico_mdcz.ab393a4e.png";